/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Create_Company_Picker_PlaceholderInputs */

const en_admin_user_create_company_picker_placeholder = /** @type {(inputs: Admin_User_Create_Company_Picker_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a company…`)
};

const de_admin_user_create_company_picker_placeholder = /** @type {(inputs: Admin_User_Create_Company_Picker_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen auswählen…`)
};

/**
* | output |
* | --- |
* | "Pick a company…" |
*
* @param {Admin_User_Create_Company_Picker_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_create_company_picker_placeholder = /** @type {((inputs?: Admin_User_Create_Company_Picker_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Create_Company_Picker_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_create_company_picker_placeholder(inputs)
	return en_admin_user_create_company_picker_placeholder(inputs)
});